import {makeChannelOptionHtml} from "./ChannelOptionHtml";

export function makeUnknownChannelOptionHtml() {
    const html = makeChannelOptionHtml('3rd Party');
    return html;
}
